var widget_default = {
  "card": "gDBY1",
  "link": "J3udo",
  "container": "mmNdx",
  "image": "-eoZZ",
  "right": "ihZ4h",
  "cardLayout": "IfQkz",
  "content": "IJWjN",
  "title": "LpvE4",
  "subtitle": "hnifu",
  "button": "kZM-Z",
  "button_disabled": "rRUh8",
  "buttonText": "_3ToSo",
  "slimLayout": "h3wTS",
  "rtl": "_0qXae",
  "ltr": "qKFiS"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
